<template>
	<div>
		<layout-1
		 	:table_name="'Invoices'"
			:id=pageid
			:searchbar=true
			:navbar=true
			:nav_items="['Add Invoice','Invoice Status']"
			:nav_item_perms="['42','77']"
			:button_perm="'41'"
			:button_name="'Select'"
			:term=term
			:reroute="'/0308'"
			:select_reroute=true
			style="width:100%; height:calc(100vh - 50px);">
		</layout-1>
	</div>
</template>

<script>
import {PAGES} from './../../../constants.js'
import api from '@/api'
import router from '@/router/index'
export default {
    props: {
		term: ''
    },
	data(){
		return{
			pageid:PAGES.INVOICES_PAGE
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/view/Invoices.vue